(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-kf-drop-data]').textContent);
    const cards = [...root.querySelectorAll('.kf-drop__item')];
    const circle = root.dataset.layout === 'circle';
    const dialog = root.querySelector('dialog');
    const focusImage = root.querySelector('.kf-drop__focus-image');
    const purchase = root.querySelector('.kf-drop__purchase');
    const sizes = root.querySelector('.kf-drop__sizes');
    const add = root.querySelector('.kf-drop__add');
    let chosen=null;
    const status = root.querySelector('.kf-drop__status');
    let active = 0, rotation = 0, previousFocus, ownsHistory = false, busy = false;
    const money = v => new Intl.NumberFormat(undefined,{style:'currency',currency:data[active].currency}).format(v/100);
    const matching = () => {
      const item = data[active], product = item.product;
      if (!product) return [];
      const colorIndex = product.options.findIndex(o => /colou?r|design/i.test(typeof o === 'string' ? o : o.name));
      if (colorIndex < 0) return product.variants;
      return product.variants.filter(v => String(v.options[colorIndex]).toLowerCase() === (item.purchaseColor||item.color).toLowerCase());
    };
    const select = (index, step) => {
      if (!data.length) return;
      const next = ((index % data.length) + data.length) % data.length;
      let delta = step ?? (next-active);
      if (step === undefined && Math.abs(delta)>data.length/2) delta -= Math.sign(delta)*data.length;
      rotation += delta;
      active = next;
      cards.forEach((card,i)=>{
        if (!circle) return;
        const angle = ((i-rotation)/data.length)*Math.PI*2-Math.PI/2;
        card.style.left=(50+43*Math.cos(angle))+'%';
        card.style.top=(50+43*Math.sin(angle))+'%';
        card.setAttribute('aria-pressed',String(i===active));
      });
      if (circle) {
        const img=root.querySelector('.kf-drop__hero img');
        img.src=data[active].image;img.alt=data[active].title+' — '+data[active].color;
        root.querySelector('.kf-drop__counter').textContent=String(active+1).padStart(2,'0')+' / '+String(data.length).padStart(2,'0');
        root.querySelector('.kf-drop__selection h2').textContent=data[active].title;
        root.querySelector('.kf-drop__selection p').textContent=[data[active].color,data[active].status].filter(Boolean).join(' — ');
      }
    };
    const close = (fromHistory=false) => {
      if (!dialog.open) return;
      dialog.close();document.documentElement.classList.remove('kf-drop-open');
      if (!fromHistory && ownsHistory && history.state?.kfDrop) history.back();
      ownsHistory=false;
      previousFocus?.focus({preventScroll:true});
    };
    const open = () => {
      if(busy)return;
      const item=data[active],variants=matching();
      const soldOut=!variants.length || /sold out/i.test(item.status||'');
      previousFocus=document.activeElement;chosen=null;
      focusImage.src=item.image;focusImage.alt=item.title+' — '+item.color;
      purchase.querySelector('h2').textContent=item.title;
      purchase.querySelector('.kf-drop__color').textContent=item.color;
      purchase.querySelector('.kf-drop__price').textContent=soldOut?'':money(variants[0].price);
      const description=purchase.querySelector('.kf-drop__description');
      description.replaceChildren();description.hidden=true;
      if(item.description){
        const parsed=new DOMParser().parseFromString(item.description,'text/html');
        const nodes=[...parsed.body.children];
        const story=nodes.find(n=>n.tagName==='P' && n.querySelector('strong')?.textContent.trim()===(item.purchaseColor||item.color));
        const detailsIndex=nodes.findIndex(n=>n.querySelector('strong')?.textContent.trim()==='Garment Details');
        if(story){
          const paragraph=document.createElement('p');
          paragraph.textContent=story.textContent.slice(story.querySelector('strong').textContent.length).trim();
          description.append(paragraph);
        }
        if(detailsIndex>=0)nodes.slice(detailsIndex).forEach(n=>description.append(document.importNode(n,true)));
        description.hidden=!description.children.length;
      }
      status.textContent='';sizes.replaceChildren();
      add.disabled=true;add.textContent=soldOut?dialog.dataset.soldOut:dialog.dataset.choose;
      const sizeIndex=item.product?.options.findIndex(o=>/size/i.test(typeof o==='string'?o:o.name));
      (soldOut?[]:variants).forEach(v=>{
        const button=document.createElement('button');button.type='button';
        button.textContent=v.options[sizeIndex];button.disabled=!v.available;button.setAttribute('aria-pressed','false');
        button.addEventListener('click',()=>{
          chosen=v;sizes.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
          purchase.querySelector('.kf-drop__price').textContent=money(v.price);
          add.disabled=false;add.textContent=dialog.dataset.add;status.textContent='';
        });sizes.append(button);
      });
      dialog.showModal();document.documentElement.classList.add('kf-drop-open');
      history.pushState({...history.state,kfDrop:true},'');ownsHistory=true;
      const initialFocus=sizes.querySelector('button:not(:disabled)')||purchase.querySelector('h2');
      if(soldOut)initialFocus.setAttribute('tabindex','-1');
      initialFocus.focus({preventScroll:true});
    };
    let browsingTitle=null, categoryTrigger=null;
    const browseBar=root.querySelector('.kf-drop__browse-bar');
    const showStyles=()=>{
      browsingTitle=null;root.classList.remove('is-color-selection');
      browseBar.hidden=true;
      const seen=new Set();
      cards.forEach((card,i)=>{
        card.hidden=seen.has(data[i].title);
        seen.add(data[i].title);
      });
      categoryTrigger?.focus({preventScroll:true});
    };
    if(!circle)root.querySelector('.kf-drop__browse-back').addEventListener('click',showStyles);
    cards.forEach((card,i)=>card.addEventListener('click',()=>{
      if(!circle && browsingTitle===null){
        categoryTrigger=card;browsingTitle=data[i].title;
        root.classList.add('is-color-selection');browseBar.hidden=false;
        const title=browseBar.querySelector('h2');title.textContent=browsingTitle;title.setAttribute('tabindex','-1');
        cards.forEach((item,j)=>item.hidden=data[j].title!==browsingTitle);
        title.focus({preventScroll:true});
        return;
      }
      select(i);open();
    }));
    if(!circle)showStyles();
    root.querySelector('.kf-drop__close').addEventListener('click',()=>close());
    dialog.addEventListener('click',e=>{if(e.target===dialog)close();});
    dialog.addEventListener('cancel',e=>{e.preventDefault();close();});
    window.addEventListener('popstate',()=>{if(dialog.open)close(true);});
    add.addEventListener('click',async()=>{
      if(busy||!chosen)return;
      const variant=chosen;busy=true;add.disabled=true;add.textContent=dialog.dataset.adding;
      sizes.querySelectorAll('button').forEach(b=>b.disabled=true);
      try{
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]})});
        const result=await response.json();if(!response.ok)throw new Error(result.description||dialog.dataset.error);
        status.textContent=dialog.dataset.added;close();
        try{
          const cartResponse=await fetch((window.Shopify?.routes?.root||'/')+'cart.js');
          if(cartResponse.ok){
            const cart=await cartResponse.json();
            document.querySelectorAll('.cart-bubble__text-count').forEach(n=>n.textContent=String(cart.item_count));
            document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'kf-first-drop',data:{variantId:String(variant.id)}}}));
          }
        }catch{}
      }catch(error){status.textContent=error.message||dialog.dataset.error;}
      finally{busy=false;add.disabled=false;add.textContent=dialog.dataset.add;sizes.querySelectorAll('button').forEach((button,i)=>button.disabled=!matching()[i].available);}
    });
    if(circle){
      root.querySelector('.kf-drop__prev').addEventListener('click',()=>select(active-1,-1));
      root.querySelector('.kf-drop__next').addEventListener('click',()=>select(active+1,1));
      root.querySelector('.kf-drop__hero').addEventListener('click',open);
      root.querySelector('.kf-drop__open').addEventListener('click',open);
      const stage=root.querySelector('.kf-drop__collection');
      let drag=null,suppressUntil=0;
      const angleAt=(e,d)=>Math.atan2(e.clientY-d.cy,e.clientX-d.cx);
      const snap=()=>{
        rotation=Math.round(rotation);
        select(rotation,0);
        stage.classList.remove('is-dragging');
      };
      stage.addEventListener('dragstart',e=>e.preventDefault());
      const startDrag=e=>{
        if(drag || !e.isPrimary || e.button!==0) return;
        if(e.target.closest('.kf-drop__prev,.kf-drop__next')) return;
        const box=stage.getBoundingClientRect();
        const cx=box.left+box.width/2,cy=box.top+box.height/2;
        const central=Math.hypot(e.clientX-cx,e.clientY-cy)<box.width*.25;
        drag={id:e.pointerId,pointerType:e.pointerType,cx,cy,x:e.clientX,y:e.clientY,moved:false,central,target:e.target.closest('button')};
        drag.angle=angleAt(e,drag);
      };
      const moveDrag=e=>{
        if(!drag || e.pointerId!==drag.id) return;
        if(!drag.moved){
          if(Math.hypot(e.clientX-drag.x,e.clientY-drag.y)<7) return;
          drag.moved=true;
          stage.classList.add('is-dragging');
          if(e.pointerType!=='touch') stage.setPointerCapture(e.pointerId);
        }
        e.preventDefault();
        const angle=angleAt(e,drag);
        if(drag.central){
          rotation-=(e.clientX-drag.x)/stage.getBoundingClientRect().width*data.length;
          drag.x=e.clientX;
          select(Math.round(rotation),0);
          return;
        }
        if(Math.hypot(e.clientX-drag.cx,e.clientY-drag.cy)<20){
          drag.angle=angle;return;
        }
        const delta=Math.atan2(Math.sin(angle-drag.angle),Math.cos(angle-drag.angle));
        rotation-=delta*data.length/(Math.PI*2);
        drag.angle=angle;
        select(Math.round(rotation),0);
      };
      const finish=e=>{
        if(!drag || e.pointerId!==drag.id) return;
        const moved=drag.moved, pointerType=drag.pointerType;
        drag=null;
        if(moved){
          suppressUntil=Date.now()+450;
          snap();
        }
        if(pointerType!=='touch' && stage.hasPointerCapture(e.pointerId)) stage.releasePointerCapture(e.pointerId);
      };
      stage.addEventListener('pointerdown',e=>{if(e.pointerType!=='touch')startDrag(e);});
      stage.addEventListener('pointermove',e=>{if(e.pointerType!=='touch')moveDrag(e);});
      const touchEvent=(e,t)=>({
        pointerId:t.identifier,pointerType:'touch',isPrimary:true,button:0,
        clientX:t.clientX,clientY:t.clientY,target:e.target,
        preventDefault:()=>{if(e.cancelable)e.preventDefault();}
      });
      stage.addEventListener('touchstart',e=>{
        if(e.touches.length!==1){
          if(drag)finish({pointerId:drag.id});
          return;
        }
        const point=touchEvent(e,e.touches[0]);
        startDrag(point);
        if(drag && drag.id===point.pointerId)point.preventDefault();
      },{passive:false});
      stage.addEventListener('touchmove',e=>{
        if(!drag || e.touches.length!==1)return;
        const t=[...e.touches].find(t=>t.identifier===drag.id);
        if(t)moveDrag(touchEvent(e,t));
      },{passive:false});
      stage.addEventListener('touchend',e=>{
        if(!drag)return;
        const t=[...e.changedTouches].find(t=>t.identifier===drag.id);
        if(!t)return;
        if(e.cancelable)e.preventDefault();
        const tapped=!drag.moved, target=drag.target;
        finish({pointerId:t.identifier});
        if(tapped && target){
          const index=cards.indexOf(target);
          if(index>=0){select(index);open();}
          else if(target.classList.contains('kf-drop__hero'))open();
        }
      },{passive:false});
      stage.addEventListener('touchcancel',()=>{if(drag)finish({pointerId:drag.id});});
      stage.addEventListener('pointerup',e=>{if(e.pointerType!=='touch')finish(e);});
      stage.addEventListener('pointercancel',e=>{if(e.pointerType!=='touch')finish(e);});
      stage.addEventListener('lostpointercapture',e=>{if(e.pointerType!=='touch' && drag?.pointerType!=='touch')finish(e);});
      stage.addEventListener('click',e=>{
        if(Date.now()<suppressUntil && e.detail!==0){
          e.preventDefault();e.stopPropagation();
        }
      },true);
      stage.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();const step=e.key==='ArrowRight'?1:-1;select(active+step,step);}});
    }
    select(0,0);
  };
  const all=()=>document.querySelectorAll('.kf-drop[data-kf-drop]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',all);
})();

